import counterpart from "counterpart";

const setLocale = (locale = "nl") => counterpart.setLocale(locale);

export default setLocale;
